import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer>
      <nav>
        <div className="nav-links-container">
          <ul className="nav-links">
            <li><a href="#about">About</a></li>
            <li><a href="#education">Education</a></li>
            <li><a href="#career">Career</a></li>
            <li><a href="#experience">Skills</a></li>
            <li><a href="#projects">Projects</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>
      </nav>
      <p className="outfit-regular">Copyright &#169; 2026 Pc-Daukiya. All Rights Reserved.</p>
    </footer>
  );
}

export default Footer;
